import CalificarAtencion from '../components/CalificarAtencion';

const CalificarAtencionPage = () => <CalificarAtencion />;

export default CalificarAtencionPage;
